import { createContext, useContext } from "react";

export type ActiveClientContextType = {
  activeClientId: string | null;
  setActiveClientId: (clientId: string | null) => void;
};

export const ActiveClientContext = createContext<ActiveClientContextType>({
  activeClientId: null,
  setActiveClientId: () => {
    // no-op
  },
});

export const useActiveClient = (): ActiveClientContextType =>
  useContext(ActiveClientContext);
